// extracted by mini-css-extract-plugin
export default {"heading":"Blog_heading__ND2Om","title":"Blog_title__EjGs+","card":"Blog_card__TPHmY","image":"Blog_image__1ATX+"};